import styled from 'styled-components'
import {Group} from 'reakit'

const Container = styled(Group)`
  display: flex;
  height: fit-content;
  backdrop-filter: blur(14px);
  border-radius: 2px;
`

export default Container
